import { AuthorizationScope } from '../AuthorizationScope'

const scope: AuthorizationScope = {
  _id: 'WORKSPACE_FILES',
  name: 'Workspace Files',
  type: 'WORKSPACE',
  description: '',
  modules: [],
  actions: ['READ', 'UPDATE', 'UPLOAD', 'DESTROY'],
}

export default scope
